// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__30Ymc","highlight":"styles_highlight__LEqqH"};